import React, { useRef } from 'react';
var VeltNotificationsPanelContentListItemTime = function (props) {
    var notification = props.notification, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-list-item-time", { ref: ref, notification: notification ? (typeof notification === "string" ? notification : JSON.stringify(notification)) : undefined }, children));
};
export default VeltNotificationsPanelContentListItemTime;
